/* eslint-disable no-underscore-dangle */

import { getNextRouteName, getPreviousRouteName } from '@lib/vue-router'
import { localizedRouteName, localizedRoute } from '@helper/localizedRouting'

export default {
  methods: {
    nextStep () {
      this.validate(() => {
        const routeName = getNextRouteName(this.$router.currentRoute)
        this._jumpToRoute(routeName)
      })
    },

    previousStep () {
      const routeName = getPreviousRouteName(this.$router.currentRoute)
      this._jumpToRoute(routeName)
    },

    _jumpToRoute (routeName) {
      if (routeName) {
        this.$router.push(this.localizedRoute(routeName))
      }
    },

    localizedRouteName,

    localizedRoute,
  },
}
